// opervex-frontend/src/layout/Sidebar/navigation.config.js

import { FaHome, FaBuilding, FaCity, FaRegUser } from "react-icons/fa";
import {
  MdOutlineSpaceDashboard,
  MdEmojiTransportation,
  MdAdUnits,
  MdOutlineDateRange,
  MdOutlineIntegrationInstructions,
  MdLocalGroceryStore,
  MdGrading,
} from "react-icons/md";
import { RiShoppingCartLine, RiLuggageDepositLine } from "react-icons/ri";
import { BiBarChart, BiSolidUserDetail } from "react-icons/bi";
import { AiOutlineFileText, AiOutlineProduct } from "react-icons/ai";
import { BsPersonBadge } from "react-icons/bs";
import { GrSystem } from "react-icons/gr";
import { HiOutlineUserGroup } from "react-icons/hi";
import { PiMapPinSimpleArea } from "react-icons/pi";
import { LuLayoutTemplate } from "react-icons/lu";
import { MdAccountBalanceWallet } from "react-icons/md";

const data = [
  {
    segment: "",
    title: "Home",
    icon: <FaHome />,
  },
  {
    segment: "Dashboard",
    title: "Dashboard",
    icon: <MdOutlineSpaceDashboard />,
  },
  {
    kind: "header",
    title: "Operação",
    children: [
      {
        segment: "Sales/SalesOrder",
        title: "Vendas",
        icon: <RiShoppingCartLine />,
        command: "SALES_ORDER",
      },
      {
        segment: "ServiceManagement/ServiceOrder",
        title: "Ordem de Serviço",
        icon: <MdEmojiTransportation />,
        command: "ORDER_SERVICE",
      },
      {
        segment: "MaterialManagement/GoodsMovement",
        title: "Movimento de Mercadoria",
        icon: <MdLocalGroceryStore />,
        command: "GOODS_MOVEMENT",
      },
      {
        segment: "Others/KardexComparison",
        title: "Kardex - Comparador",
        icon: <MdGrading />,
        command: "KARDEX_COMPARISON",
      },
    ],
  },

  {
    kind: "header",
    title: "Cadastros",
    children: [
      {
        segment: "MaterialManagement",
        title: "Gestão de Material",
        command: "REGISTRATION",
        children: [
          {
            segment: "Product",
            title: "Produtos",
            icon: <AiOutlineProduct />,
            command: "PRODUCTS",
          },
          {
            segment: "Category",
            title: "Categorias",
            icon: <AiOutlineFileText />,
            command: "CATEGORIES",
          },
          {
            segment: "StorageLocation",
            title: "Depósitos",
            icon: <RiLuggageDepositLine />,
            command: "STORAGE_LOCATION",
          },
          {
            segment: "UnitsMeasure",
            title: "Unidade de Medida",
            icon: <MdAdUnits />,
            command: "UNIT_MEASUREMENT",
          },
        ],
      },
      {
        segment: "ServiceManagement",
        title: "Gestão de Serviços",
        command: "REGISTRATION",
        children: [
          {
            segment: "Service",
            title: "Serviços",
            icon: <AiOutlineFileText />,
            command: "SERVICES",
          },
        ],
      },
      {
        segment: "Accounting",
        title: "Geral",
        command: "REGISTRATION",
        children: [
          { segment: "Customers", title: "Clientes", icon: <FaRegUser />, command: "CUSTOMERS" },
          { segment: "Vendors", title: "Fornecedores", icon: <FaRegUser />, command: "VENDORS" },
        ],
      },
    ],
  },
  {
    segment: "Report",
    title: "Relatórios",
    icon: <BiBarChart />,
    command: "REPORTS",
    children: [
      {
        segment: "GoodsMovement",
        title: "Movimentação",
        icon: <AiOutlineFileText />,
        command: "REPORT_GOODS_MOVEMENT",
      },
      {
        segment: "GoodsMovementFull",
        title: "Movimentação Completo",
        icon: <AiOutlineFileText />,
        command: "REPORT_GOODS_MOVEMENT_FULL",
      },
      {
        segment: "ServiceOrder",
        title: "Ordem de Serviço",
        icon: <AiOutlineFileText />,
        command: "REPORT_SERVICE_ORDER",
      },
      {
        segment: "Stock",
        title: "Estoque",
        icon: <AiOutlineFileText />,
        command: "REPORT_STOCK",
      },
      {
        segment: "StockSerial",
        title: "Estoque Serial",
        icon: <AiOutlineFileText />,
        command: "REPORT_STOCK_SERIAL",
      },
      {
        segment: "StockSerialDays",
        title: "Serial - Dias em Estoque",
        icon: <AiOutlineFileText />,
        command: "REPORT_SERIAL_DAYS_DEPOSIT",
      },
      {
        segment: "SalesOrder",
        title: "Ordens de Venda",
        icon: <AiOutlineFileText />,
        command: "REPORT_SALES_ORDER",
      },
    ],
  },
  {
    kind: "header",
    title: "Recusrsos Humanos",
    segment: "HumanResources",
    children: [
      {
        segment: "Employee",
        title: "Funcionários",
        icon: <BsPersonBadge />,
        command: "EMPLOYEE",
      },
      {
        segment: "Roles",
        title: "Cargos",
        icon: <BiSolidUserDetail />,
        command: "ROLE_EMPLOYEE",
      },
      {
        segment: "Sectors",
        title: "Setores",
        icon: <PiMapPinSimpleArea />,
        command: "EMPLOYEE_SECTOR",
      },
      {
        segment: "Teams",
        title: "Equipes",
        icon: <HiOutlineUserGroup />,
        command: "EMPLOYEE_TEAM",
      },

      {
        segment: "Integrations",
        title: "Integração",
        icon: <MdOutlineIntegrationInstructions />,
        command: "HR_INTEGRATION",
      },
    ],
  },

  {
    kind: "header",
    title: "Contabilidade",
    children: [
      {
        segment: "Accounting/Branch",
        title: "Empresa - Filial",
        icon: <FaBuilding />,
        command: "USER_PROFILE",
      },
      {
        segment: "Accounting/City",
        title: "Cidades",
        icon: <FaCity />,
        command: "CITY",
      },
      {
        segment: "Accounting/FiscalPeriod",
        title: "Período Fiscal",
        icon: <MdOutlineDateRange />,
        command: "FISCAL_PERIOD",
      },
      {
        segment: "Accounting/CostCenters",
        title: "Centros de Custo",
        icon: <BiBarChart />,
        command: "COST_CENTER",
      },
    ],
  },
  {
    kind: "header",
    title: "Financeiro",
    children: [
      {
        segment: "Financial/Entries",
        title: "Lançamentos Financeiros",
        icon: <MdAccountBalanceWallet />,
        command: "FINANCIAL_ENTRY",
      },
      {
        segment: "Financial/Accounts",
        title: "Contas Financeiras",
        icon: <MdAccountBalanceWallet />,
        command: "FINANCIAL_ACCOUNTS",
      },
      {
        segment: "Financial/Categories",
        title: "Categorias Financeiras",
        icon: <MdAccountBalanceWallet />,
        command: "FINANCIAL_CATEGORIES",
      },
    ],
  },
  {
    kind: "header",
    title: "Configuração",
    children: [
      {
        segment: "System",
        title: "Usuário",

        children: [
          {
            segment: "User",
            title: "Usuário",
            icon: <FaRegUser />,
            command: "USER_SYSTEM",
          },
          {
            segment: "AccessProfile",
            title: "Acessos",
            icon: <BiBarChart />,
            command: "USER_PROFILE",
          },
        ],
      },
      {
        segment: "System",
        title: "Sistema",
        children: [
          {
            segment: "OperationGoodsMovement",
            title: "Operação - Movimentação Mercadoria",
            icon: <MdAdUnits />,
            command: "OPERATION_GM",
          },
          {
            segment: "Template",
            title: "Templates",
            icon: <LuLayoutTemplate />,
            command: "TEMPLATES",
          },
          {
            segment: "Setting",
            title: "Configuração do Sistema",
            administrator: true,
            icon: <GrSystem />,
            command: "SYSTEM",
          },
        ],
      },
    ],
  },
];

export default data;
